'use strict';

module.exports = {
  OpenBio: require('./devices/OpenBio'),
  OpenSpectro: require('./devices/OpenSpectro'),
  SimpleSpectro: require('./devices/SimpleSpectro'),
  Solar2015: require('./devices/Solar2015'),
  Beemos: require('./devices/Beemos'),
  Computer: require('./devices/Computer')
};



// WEBPACK FOOTER //
// ./src/index.js